module.exports = __webpack_public_path__ + "img/arrow-small-white.47cba1ae.svg";